module.exports = __webpack_public_path__ + "media/images/new-ui-images/basic-icon-f8ccbefc5ca4deebbbede55bb8a4e94f.svg";